/**
 * Stellt Methoden für die Behandlung von Links bereit.
 *
 * @class service_v3sLinkService
 * @memberOf v3sWbtPlayerApp:page:elements
 */

angular.module('v3sWbtPlayerApp').factory('v3sLinkService', ["$window", "v3sNavigationService", "v3sWbtDataService", "v3sContentMediaPath", function ($window, v3sNavigationService, v3sWbtDataService, v3sContentMediaPath) {

    function findItem(path) {
        // Link in kanonische Form überführen
        if (path && path.indexOf("./") == 0) {
            path = path.substring(2);
        }

        // Seite mit diesem Dateinamen suchen
        var wbt = v3sWbtDataService.getWbt();
        return wbt.getItem(path);
    }

    /**
    * Wandelt den übergebenen Pfad in einen Medienpfad um.
    *
    * @memberOf v3sWbtPlayerApp:page:elements.service_v3sLinkService
    * @param {string} path - die aufzurufende Adresse
    */
    function convertMediaPath(path) {
        if (path && path.indexOf("./") == 0) {
            return v3sContentMediaPath + path.substring(2);
        }

        return path;
    }

    /**
    * Öffnet die Seite mit dem übergebenen Pfad. Öffnet ein neues Fenster für externe Links.
    *
    * @memberOf v3sWbtPlayerApp:page:elements.service_v3sLinkService
    * @param {string} path - die aufzurufende Adresse
    */
    function openLink(path) {
        var item = findItem(path);

        if (item) {
            v3sNavigationService.goTo(v3sNavigationService.getPageState(item));
        } else if (path) {
            $window.open(convertMediaPath(path));
        }
    }

    return {
        openLink: openLink,
        findItem: findItem,
        convertMediaPath: convertMediaPath
    }
}]);